/* eslint-disable jsdoc/check-tag-names -- Introduced in TP-9489. */
/* eslint-disable jsdoc/check-types -- Introduced in TP-9489. */
/* eslint-disable jsdoc/require-returns -- Introduced in TP-9489. */
/* eslint-disable jsdoc/tag-lines -- Introduced in TP-9489. */

/**
 * Třída, která by se měla pouze dědit a nevytvářet její instance.
 * Obsahuje pomocné metody např. pro práci s DOM atd.
 */
class Tools {
	/**
	 * Přiřadí každý prvek z pole childs parentovi.
	 * @param {*} parent Rodičovský element.
	 * @param {[array]} childs Pole elementů.
	 */
	static appendChilds(parent, ...childs) {
		childs.forEach((child) => {
			if (child) {
				parent.appendChild(child);
			}
		});
	}

	/**
	 * Vytvoří element se specifikací, kterou deklarujeme při volání funkce.
	 * @param {string} type Typ vytvářeného elementu.
	 * @param {object} specifications Objekt obsahující specifikace jednoho HTML elementu (type, class, name, atd.)
	 * @return {object} Vrací HTML objekt vytvořený podle specifikací.
	 * @example
	 * let newElement = createElement('div', {
	 *     'class': 'trida1 trida2 trida3',
	 *     'data-id': 'div0001'
	 * });
	 */
	static createElement(type, specifications = {}) {
		const newElement = document.createElement(type);

		for (const attribute in specifications) {
			if (
				attribute === 'innerHTML' ||
				attribute === 'innerText' ||
				attribute === 'checked'
			) {
				newElement[attribute] = specifications[attribute];
			} else {
				newElement.setAttribute(attribute, specifications[attribute]);
			}
		}

		return newElement;
	}

	/**
	 * Tato funkce navěšuje posluchače na elementy.
	 * @param {object} elements - Objekt obsahující html elementy.
	 * @param {string} event - Název události.
	 * @param {function} fn - Funkce, která se má zavolat při události.
	 */
	static addListener(elements, event, fn) {
		Array.from(elements).forEach((element) =>
			element.addEventListener(event, fn),
		);
	}

	/**
	 * Tato funkce odvěšuje posluchače z elementů.
	 * @param {object} elements - Objekt obsahující html elementy.
	 * @param {string} event - Název události.
	 * @param {function} fn - Funkce, která se volala při události.
	 */
	static removeListener(elements, event, fn) {
		Array.from(elements).forEach((element) =>
			element.removeEventListener(event, fn),
		);
	}

	/**
	 * Formátuje dané číslo na:
	 * 1 000, 10 000...
	 * @param {number} value
	 * @return {string}
	 */
	static formatInteger(value) {
		return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '\u0020');
	}

	/**
	 * Formátuje dané číslo na:
	 * 1 000, 10 000,1212...
	 * @param {number} value
	 * @return {string}
	 */
	static formatFloat(value) {
		return value.toLocaleString('cs-CZ', {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		});
	}

	/**
	 * Formátuje dané číslo do 0,20%.
	 * @param {number} value
	 * @return {string}
	 */
	static formatPercent(value) {
		return (value.toFixed(2) + '\u0020%').replace('.', ',');
	}

	/**
	 * Vrátí jméno měny.
	 * @return {string}
	 */
	static getCurrencyName() {
		return '\u0020Kč';
	}

	/**
	 * Formátuje dané číslo do 32,20 Kč apod.
	 * @param {number} value
	 * @return {string}
	 */
	static formatCurrency(value) {
		return this.formatFloat(value) + this.getCurrencyName();
	}

	/**
	 * Formatuje hodnotu dodanou z API.
	 * @param {?number} [value]
	 * @param {string} [type] ctr, cpt, ...
	 * @return {string} Vrací formátovanou hodnotu.
	 */
	static formatValue(value, type = '') {
		if (value === undefined || value === null) {
			return '-';
		}

		switch (type) {
			case 'ctr':
				return this.formatPercent(value);
			case 'cpt':
				return this.formatCurrency(value);
			case 'impressions':
				return this.formatInteger(value);
			case 'commission':
				return this.formatCurrency(value);
			case 'percent':
				return this.formatPercent(value);
			case 'currency':
				return this.formatCurrency(value);
			case 'float':
				return this.formatFloat(value);
			case 'number':
				return this.formatInteger(value);
			default:
				return value;
		}
	}

	/**
	 * Vytvoří tooltip.
	 * @param {string} text
	 * @param {string} title
	 * @return {Element} Vrací sestavený tooltip.
	 */
	static createTooltip(text, title = '') {
		const tooltip = this.createElement('div', {
			class: 'Tooltip',
			innerHTML: `
					<span class='Tooltip-show'></span>
					<div class='Tooltip-cont'>
						<h6 class='Tooltip-title'>${title}</h6>
						<div class='Tooltip-text'>
							<p>${text}</p>
						</div>
					</div>
				`,
		});

		return tooltip;
	}

	/**
	 * Získá uživatelské nastavení pro select boxy z local storage.
	 * Pokud je úložiště prázdné, tak je nastavené na defaultní hodnoty.
	 * @param {string} name Jméno itemu.
	 * @param {any} defaultData Výchozí hodnoty pokud item není nalezen.
	 */
	static getFromLocalStorage(name, defaultData = {}) {
		let data = {};
		const storage = localStorage.getItem(name);

		if (storage) {
			data = JSON.parse(storage);
		} else {
			data = defaultData;
			this.updateLocalStorage(name, data);
		}

		return data;
	}

	/**
	 * Nahraje aktuální hodnoty do local storage.
	 * @param {string} name Jméno itemu.
	 * @param {any} data Data.
	 */
	static updateLocalStorage(name, data) {
		localStorage.setItem(name, JSON.stringify(data));
	}

	/**
	 * Vloží daný element za vybraný.
	 * @param {Element} newNode Nově vkládaný element.
	 * @param {Element} referenceNode Element, za který bude nový element vložen.
	 */
	static insertAfter(newNode, referenceNode) {
		referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
	}

	/**
	 * Najde rodičovský element s danou třídou.
	 * @param {Element} element Element jehož rodič bude hledán.
	 * @param {string} searchedClass Třída hledaného rodiče.
	 */
	static getParentByClass(element, searchedClass) {
		let parent = element.parentNode;

		while (
			parent.nodeName !== 'BODY' &&
			!parent.classList.contains(searchedClass)
		) {
			parent = parent.parentNode;
		}

		return parent.classList.contains(searchedClass) ? parent : null;
	}

	/**
	 * Odstraní element z domu.
	 * @param {Element} element
	 */
	static removeElement(element) {
		const parent = element.parentElement;

		if (parent) {
			parent.removeChild(element);
		}
	}

	/**
	 * Funkce na prohazování class. Nahrazuje funkci replace().
	 * @param {object} element HTML objekt
	 * @param {string} classA prvni class
	 * @param {string} classB druha class
	 * @return {string} string || boolean vrací novou classu nebo false
	 */
	static replaceClass(element, classA, classB) {
		if (element.classList.contains(classA)) {
			element.classList.remove(classA);
			element.classList.add(classB);

			return classB;
			// eslint-disable-next-line no-else-return -- Introduced in TP-9489.
		} else if (element.classList.contains(classB)) {
			element.classList.remove(classB);
			element.classList.add(classA);

			return classA;
		} else {
			return false;
		}
	}

	/**
	 * Najde rodičovský element s danou třídou.
	 * @param {Element} element
	 * @param {string} searchedClass
	 * @return {*} Vrací Element nebo null, pokud není nalezen.
	 */
	static getParentWithClass(element, searchedClass) {
		let searchedElement = null;

		if (element.classList.contains(searchedClass)) {
			return element;
		}

		while (element.parentElement) {
			if (element.parentElement.classList.contains(searchedClass)) {
				searchedElement = element.parentElement;

				break;
			}

			element = element.parentElement;
		}

		return searchedElement;
	}

	/**
	 * Vrací true, pokud jsem v safari.
	 * @return {boolean}
	 */
	static isSafari() {
		return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	}

	/**
	 * Vrací funkci, která nemůže být volána častěji,
	 * než hodnota wait (ms).
	 * @param {function} func
	 * @param {number} wait Čas v ms.
	 * @param {boolean} immediate Funkce bude zavolána okamžitě.
	 */
	static debounce(func, wait, immediate) {
		let timeout = null;

		return function () {
			const context = this;
			const args = arguments;

			const later = function () {
				timeout = null;

				if (!immediate) {
					func.apply(context, args);
				}
			};

			const callNow = immediate && !timeout;

			clearTimeout(timeout);
			timeout = setTimeout(later, wait);

			if (callNow) {
				func.apply(context, args);
			}
		};
	}
}

export default Tools;
